import React from 'react';

class Utilities {
    //.toFixed by itself sometimes doesn't round properly
    static roundToDecimal(n, digits) {
        var negative = false;
        if (digits === undefined) {
            digits = 0;
        }
        if (n < 0) {
            negative = true;
            n = n * -1;
        }
        var multiplicator = Math.pow(10, digits);
        n = parseFloat((n * multiplicator).toFixed(11));
        n = (Math.round(n) / multiplicator).toFixed(2);
        if (negative) {
            n = (n * -1).toFixed(2);
        }
        return n;
    }

    static convertToCurrency(num) {
        return this.roundToDecimal(num, 2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    static removeCurrencyFormatting(amount) {
        return amount.replace(/[$,]+/g, "");
    }

    static isValidDecimalValue(num) {
        return num && num.match(/^\d{1,}(\.\d{0,2})?$/);
    }

    static convertToJavascriptDate(dateTime) {
        return new Date(Date.parse(dateTime)).toLocaleDateString();
    }

    static padDateString(num) {
        return num < 10 ? "0" + num : +num;
    }

    static formatDateWithLeadingZeros(date) {
        return `${this.padDateString(date.getMonth() + 1)}/${this.padDateString(date.getDate())}/${date.getFullYear()}`;
    }

    static renderEnumToSelectOptions(enumObject) {
        var options = [];
        Object.keys(enumObject).forEach((enumVal) => {
            if (enumVal !== "name" && enumVal !== "None") {
                options.push(<option key={enumObject[enumVal]} value={enumObject[enumVal]}>{enumObject.name[enumObject[enumVal]]}</option>);
            }
        });
        return options;
    }

    static isValidDate(date) {
        return date instanceof Date && !isNaN(date);
    }

    static getNextWeekDate(dayOfWeek) {
        var date = new Date();

        var dateToSet = date.getDate() - date.getDay() + (date.getDay() < dayOfWeek ? dayOfWeek : (dayOfWeek + 7));

        return new Date(date.setDate(dateToSet));
    }

    static getNextBiMonthlyDate() {
        var date = new Date();
        if (date.getDate() < 15) {
            return new Date(date.getFullYear(), date.getMonth(), 15);
        }
        else if (new Date(date.getFullYear(), date.getMonth(), date.getDate()) === this.getNextLastDayOfMonthDate()) {
            return new Date(date.getFullYear(), date.getMonth() + 1, 15);
        }
        else {
            return this.getNextLastDayOfMonthDate();
        }
    }

    static getNextLastDayOfMonthDate() {
        var date = new Date();
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    static getNextMonthlyDate(dayOfMonth) {
        var date = new Date();

        if (dayOfMonth === 0) {
            return this.getNextLastDayOfMonthDate();
        }

        if (dayOfMonth <= date.getDate()) {
            return new Date(date.getFullYear(), date.getMonth() + 1, dayOfMonth);
        }

        return new Date(date.getFullYear(), date.getMonth(), dayOfMonth);
    }
}

export default Utilities;